export default __webpack_public_path__ + "static/part1_5mb-a256c8b4d4cfb2ce443faa8e4490a138.png";